// extracted by mini-css-extract-plugin
export default {"Flash":"PublishBanners-module__Flash__i3lpom3"};